import { useNavigate } from 'react-router-dom';

const factors = [
  {
    icon: 'ri-speed-line',
    title: 'Скорость загрузки сайта',
    desc: 'Медленный сайт = высокий показатель отказов = дорогие клики. Google и Яндекс напрямую учитывают скорость при расчёте ставки.',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Качество программного кода',
    desc: 'Чистый, валидный код сигнализирует поисковикам о надёжности ресурса и влияет на технический показатель качества.',
  },
  {
    icon: 'ri-user-follow-line',
    title: 'Поведенческие характеристики',
    desc: 'Как долго люди находятся на сайте, не уходят ли они сразу — поисковики видят это всё и снижают или повышают стоимость клика.',
  },
  {
    icon: 'ri-links-line',
    title: 'Релевантность страницы',
    desc: 'Насколько страница соответствует тому, что человек искал и что было написано в объявлении. Полное совпадение = дешевле клик.',
  },
  {
    icon: 'ri-history-line',
    title: 'Карма домена',
    desc: 'История вашего сайта: санкции прошлых лет, возраст домена и репутация ресурса влияют на то, как к нему относятся рекламные системы.',
  },
];

export default function ContextAdsWhySite() {
  const navigate = useNavigate();

  return (
    <section id="context-ads-why-site" className="py-12 sm:py-24 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-alert-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              ВЕБ-САЙТ
            </span>
          </div>
          <h2 className="text-xl sm:text-3xl md:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight max-w-4xl mx-auto">
            Почему для успеха контекстной рекламы критически важен веб-сайт с маркетинговой архитектурой?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full mb-6"></div>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify sm:text-center">
            Даже самая идеальная реклама не принесёт прибыли, если сайт работает плохо. Поисковые системы
            (Яндекс и Google) оценивают <strong>«Показатель качества»</strong>, который напрямую влияет на
            стоимость клика и позицию вашего объявления.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 mb-10 sm:mb-14">
          {factors.map((f, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-5 sm:p-7 border border-gray-100 hover:border-[#C5A880]/40 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#1A2B4C] group-hover:bg-[#C5A880] rounded-xl mb-4 transition-colors duration-300 flex-shrink-0">
                <i className={`${f.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-sm sm:text-base font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-2 leading-snug">
                {f.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-500 leading-relaxed font-['Montserrat'] text-justify">
                {f.desc}
              </p>
            </div>
          ))}
        </div>

        {/* CTA block */}
        <div className="bg-gradient-to-r from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl p-6 sm:p-10">
          <div className="text-center mb-6 sm:mb-8">
            <h3 className="text-lg sm:text-2xl md:text-3xl font-['Playfair_Display'] font-bold text-white mb-3 leading-snug">
              Ваш сайт готов получать рекламный трафик?
            </h3>
            <p className="text-white/70 text-sm font-['Montserrat'] max-w-2xl mx-auto leading-relaxed text-justify sm:text-center">
              Прежде чем вкладывать бюджет в рекламу, убедитесь, что ваш сайт способен конвертировать
              посетителей в клиентов. Мы поможем разобраться.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              type="button"
              onClick={() => navigate('/audit-landing-page')}
              className="group w-full sm:w-auto bg-[#C5A880] hover:bg-[#B39770] text-white px-6 sm:px-8 py-4 rounded-full text-xs sm:text-sm font-semibold transition-all duration-300 hover:scale-105 sm:whitespace-nowrap cursor-pointer font-['Montserrat'] flex items-center justify-center gap-2 text-center leading-snug"
            >
              <i className="ri-search-eye-line flex-shrink-0"></i>
              Заказать экспертный аудит вашего веб-сайта
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
            </button>
            <button
              type="button"
              onClick={() => navigate('/landing-page')}
              className="group w-full sm:w-auto bg-white/20 hover:bg-white/30 text-white border-2 border-white/40 px-6 sm:px-8 py-4 rounded-full text-xs sm:text-sm font-semibold transition-all duration-300 sm:whitespace-nowrap cursor-pointer font-['Montserrat'] flex items-center justify-center gap-2 backdrop-blur-sm text-center leading-snug"
            >
              <i className="ri-layout-line flex-shrink-0"></i>
              Разработать веб-сайт с встроенным SEO
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
